import {Analytics, GTag, GTagEventObserver, GTagPageviewObserver} from '@plaudit/analytics';
import FacebookPixel from "@plaudit/analytics/dist/tracker/FacebookPixel";

Analytics.setup();

const gtag = GTag.getInstance();
const facebookPixel = FacebookPixel.getInstance();

if (gtag !== null) {
	// Goal: Email Link - Click
	gtag.addObserver(
		new GTagEventObserver(
			{
				eventCategory:	(value: string) => value === "Email Link",
				eventAction:	(value: string) => value === "Click"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
			}
		)
	);

	// Goal: Telephone Link - Click
	gtag.addObserver(
		new GTagEventObserver(
			{
				eventCategory:	(value: string) => value === "Telephone Link",
				eventAction:	(value: string) => value === "Click"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
			}
		)
	);

	// Goal: Form Submit - Contact
	gtag.addObserver(
		new GTagEventObserver(
			{
				eventCategory:	(value: string) => value === "JSF Action",
				eventAction:	(value: string) => value.indexOf("$contact.submit") !== -1
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
			}
		)
	);

	// Goal: Form Submit - Get Quote
	gtag.addObserver(
		new GTagEventObserver(
			{
				eventCategory:	(value: string) => value === "Get Quote Form",
				eventAction:	(value: string) => value === "Submit"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
			}
		)
	);

	// Goal: Chat - Started
	gtag.addObserver(
		new GTagEventObserver(
			{
				eventCategory:	(value: string) => value === "LiveHelpNow",
				eventAction:	(value: string) => value === "Chat-started"
			},
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 100});
			}
		)
	);
}